export default {
  news: {
    listTitle: 'News List',
    items: [
      {
        id: 'scholarship-repayment-2024',
        date: 'Aug. 15, 2024',
        category: 'Human Resources',
        title: 'New Student Loan Repayment Support Program',
        summary: 'We are pleased to announce a new Student Loan Repayment Support Program for all full-time employees. This program aims to help reduce the financial burden of student loans, enabling our team to focus on their careers and personal growth.',
        content: [
          'Specifically, the program offers monthly subsidies toward employees\' loan repayments, allowing them to alleviate financial stress and fully dedicate themselves to developing their skills and advancing in their roles.',
          'Through initiatives like this, we aim to make meaningful contributions to society while pursuing our ambitious goal of reaching 1 trillion yen in revenue. Though this program may be a small step, we believe it forms an important foundation for creating a lasting positive impact.',
        ],
      },
      { id: 'relocation-chuo-2023', date: 'Jun. 5, 2023', category: 'Company News', title: 'We Relocated to Chuo-ku, Osaka', summary: '', content: [] },
      { id: 'trade-terminology-2015', date: 'Apr. 1, 2023', category: 'Service Update', title: 'Trade Terms Glossary Page Launched', link: '/import-export-terms', summary: '', content: [] },
      { id: 'relocation-kita-2014', date: 'Dec. 8, 2014', category: 'Company News', title: 'Relocated to Kita-ku, Osaka', summary: '', content: [] },
      { id: 'general-export-2008', date: 'May. 23, 2008', category: 'Licensing & Compliance', title: 'Obtained Comprehensive Export License', summary: '', content: [] },
      { id: 'narcotic-importer-2004', date: 'Dec. 6, 2004', category: 'Licensing & Compliance', title: 'Obtained Certificate of Acceptance for Notification of Business as an Importer of Narcotic Raw Materials', link: '/docs/import_edraw_materials.pdf', summary: '', content: [] },
      { id: 'narcotic-exporter-2004', date: 'Dec. 6, 2004', category: 'Licensing & Compliance', title: 'Obtained Certificate of Acceptance for Notification of Business as an Exporter of Narcotic Raw Materials', link: '/docs/raw_material_exports.pdf', summary: '', content: [] },
      { id: 'toxic-importer-2004', date: 'Oct. 4, 2004', category: 'Licensing & Compliance', title: 'Registered as a Poisonous and Deleterious Substances Importer', link: '/docs/import_poison.pdf', summary: '', content: [] },
      { id: 'toxic-seller-2004', date: 'Sep. 21, 2004', category: 'Licensing & Compliance', title: 'Registered as a General Seller of Poisonous and Deleterious Substances', link: '/docs/poison_for_sale.pdf', summary: '', content: [] },
    ],
  },
  newsDetail: {
    recentNews: 'Recent News',
    backToNews: 'Back to News',
    backToNewsList: 'Back to News List',
    notFound: {
      title: 'Article Not Found',
      description: 'The news article you are looking for does not exist or has been removed.',
      back: 'Back to News',
    },
  },
  notFound: {
    title: 'This page has not been generated',
    suggestion: 'Tell me more about this page, so I can generate it',
  },
};
